import api from '../../../core/api/api';

const BASE = '/Contabilidad';

export const entradasMensualesAPI = {
  getEntradas: (mes, anio, idCentro) =>
    api.get(`${BASE}/EntradasMensuales`, { params: { mes, anio, idCentro } }).then(r => r.data),

  crearEntrada: (data) =>
    api.post(`${BASE}/EntradasMensuales`, data).then(r => r.data),

  actualizarEntrada: (id, data) =>
    api.put(`${BASE}/EntradasMensuales/${id}`, data).then(r => r.data),

  eliminarEntrada: (id) =>
    api.delete(`${BASE}/EntradasMensuales/${id}`).then(r => r.data),
};
